import type { AnimationProperties, AnimationsKit } from '../../types';

const name = 'BaseFilter';
const properties: Partial<AnimationProperties> = {};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[] | HTMLElement | HTMLCollection,
  duration: number = 0,
  delay: number = 0,
  params: any = {},
) {
  return kit.engine.tween(elements, { duration, delay, ...params }, ['filter']);
}

export { name, properties, animate };
